<template>
  <div>
    <p v-if="contactNumber" class="notification_label">You received a call on a lead from {{ contactNumber }}</p>
    <p v-else class="notification_label">You received a call on a lead</p>
    <button-link @click="goToLead">{{ notification.data.record_address }}</button-link>
  </div>
</template>

<script>
import router from "../../../router";
import api from "../../../api";
import dates from "../../../services/dates";
import utils from "../../../services/utils";

export default {
  name: "NewCallNotification",
  props: {
    notification: Object
  },
  computed: {
    contactNumber() {
      if (this.notification.data.hasOwnProperty('contact_number')) {
        return utils.formatNumber(this.notification.data.contact_number)
      }
      return null
    },
  },
  methods: {
    goToLead() {
      api.notifications.markRead({ notification_id: this.notification.id }).then(() => {
        // NOTE: The database read_at will be different from now, but read_at just needs a date
        // in order for this to work. We don't show the read at time.
        this.notification.read_at = dates.getNowISO()
      })
      router.replace({query: {lead: this.notification.data.record_id}});
    },
  },
}
</script>

<style lang="scss" scoped>
.notification_label {
  margin-bottom: 2px;
  font-size: 0.875rem;
}
</style>
